export enum TaskStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING", // Legacy alias?
  PROCESSING = "PROCESSING", // Project model uses this
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  DRAFT = "DRAFT"
}
